export const LOCAL_RECORDING_SLIDES_CANVAS_FPS = 1;
export const LOCAL_RECORDING_SLIDES_PUBLISHING_TIMEOUT = 5;
// Static slides only change on a page turn; animated decks need a real frame rate to record the
// step animations rather than only their end state.
export const ANIMATED_SLIDES_CANVAS_FPS = 24;
export const ANIMATED_SLIDES_PLAYER_READY_TIMEOUT_MS = 15000;
